import { Component, EventEmitter, inject, Input, Output, ContentChildren, QueryList, AfterContentInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { UtilsService } from 'src/app/common';

@Component({
    selector: 'gig-confirmation-dialog',
    standalone: true,
    imports: [CommonModule, DialogModule, ButtonModule],
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent {

    private util = inject(UtilsService);

    @Input() visible: boolean = false;
    @Input() type: 'delete' | 'confirm' | 'warning' = 'delete';
    @Input() showIcon: boolean = false;
    @Input() title: string = '';
    @Input() message: string = '';
    @Input() icon: string = '';
    @Input() iconColor: string = '';
    @Input() confirmButtonClass: string = '';
    @Input() width: string = '500px';
    @Input() hasProjectedContent: boolean = false;
    
    @Output() visibleChange = new EventEmitter<boolean>();
    @Output() confirmed = new EventEmitter<void>();
    @Output() cancelled = new EventEmitter<void>();

    get dialogIcon(): string {
        if (this.icon) return this.icon;
        
        switch (this.type) {
            case 'delete':
                return 'pi pi-exclamation-triangle';
            case 'confirm':
                return 'pi pi-check-circle';
            case 'warning':
                return 'pi pi-exclamation-triangle';
            default:
                return 'pi pi-exclamation-triangle';
        }
    }

    get dialogIconColor(): string {
        if (this.iconColor) return this.iconColor;
        
        switch (this.type) {
            case 'delete':
                return '#b91c1c'; // red-700
            case 'confirm':
                return '#16a34a'; // green-600
            case 'warning':
                return '#ea580c'; // orange-600
            default:
                return '#b91c1c';
        }
    }

    get buttonClass(): string {
        if (this.confirmButtonClass) return this.confirmButtonClass;
        
        switch (this.type) {
            case 'delete':
                return 'btn-delete';
            case 'confirm':
                return 'btn-confirm';
            case 'warning':
                return 'btn-warning';
            default:
                return 'btn-delete';
        }
    }

    onHide(): void {
        this.util.logger.info('onHide called, setting visible to false');
        this.visible = false;
        this.visibleChange.emit(false);
    }

    onCancel(): void {
        this.util.logger.info('onCancel called');
        this.cancelled.emit();
        this.onHide();
    }

    onConfirm(): void {
        this.util.logger.info('onConfirm called');
        this.confirmed.emit();
        this.onHide();
    }

}
